<template>
  <v-banner
    v-if="isImpersonating"
    color="warning"
    class="impersonation-banner"
    lines="one"
    sticky
  >
    <template v-slot:prepend>
      <v-icon size="small">fa-solid fa-user-secret</v-icon>
    </template>
    <div class="d-flex align-center justify-space-between" style="width: 100%;">
      <span class="text-body-2 font-weight-medium">
        🛡️ Admin Mode: Viewing as {{ impersonationTarget }}
      </span>
      <v-btn
        size="small"
        variant="elevated"
        color="error"
        @click="stopImpersonation"
        :loading="stopping"
      >
        <v-icon start size="small">fa-regular fa-right-from-bracket</v-icon>
        Exit Impersonation
      </v-btn>
    </div>
  </v-banner>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { showNotification } from '../../stores/notification'

const isImpersonating = ref(false)
const impersonationTarget = ref('')
const stopping = ref(false)

const checkImpersonationStatus = () => {
  isImpersonating.value = localStorage.getItem('impersonation_active') === 'true'
  impersonationTarget.value = localStorage.getItem('impersonation_target') || ''
}

const stopImpersonation = async () => {
  stopping.value = true
  try {
    // Clear impersonation flags first
    localStorage.removeItem('impersonation_active')
    localStorage.removeItem('impersonation_target')
    localStorage.removeItem('admin_original_uid')
    localStorage.removeItem('admin_original_email')
    
    showNotification('Exiting impersonation mode...', 'info')
    
    // Import Firebase auth and sign out
    const { signOutUser } = await import('../../firebase/auth')
    await signOutUser()
    
    // Redirect to login page
    window.location.href = '/login'
    
  } catch (error) {
    console.error('Failed to stop impersonation:', error)
    showNotification('Failed to exit impersonation', 'error')
  } finally {
    stopping.value = false
  }
}

onMounted(() => {
  checkImpersonationStatus()
  
  // Listen for storage changes (in case impersonation is started in another tab)
  window.addEventListener('storage', checkImpersonationStatus)
})
</script>

<style scoped>
.impersonation-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.impersonation-banner :deep(.v-banner__content) {
  width: 100%;
}
</style>
